import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import SectionHeading from "@/components/base/SectionHeading";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import EditorPicks from "@/pages/home/components/EditorPicks";
import NewsPreview from "@/pages/home/components/NewsPreview";
import SpecialPreview from "@/pages/home/components/SpecialPreview";
import AboutBand from "@/pages/home/components/AboutBand";
import { usePageMeta } from "@/hooks/usePageMeta";

const HOME_TITLE = "奸情影视剧推荐与剧情解析 - 专注精彩影视内容";
const HOME_DESCRIPTION =
  "奸情影视内容站为您提供丰富的影视剧资源，涵盖最新影视剧推荐、剧情介绍和影视资讯，让您轻松了解影视精彩故事和角色发展。";

export default function Home() {
  usePageMeta({
    title: HOME_TITLE,
    description: HOME_DESCRIPTION,
    keywords: "奸情,影视剧,剧情介绍,影视推荐,影视资讯,影视内容,影片解说",
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full">
        <HeroCarousel />

        <section className="w-full px-4 py-12 md:px-8 md:py-16 lg:px-12">
          <SectionHeading
            kicker="Browse by Genre"
            title="按类型快速进入"
            description="不知道从哪部开始？先选一个你现在最想看的心情。"
            actionLabel="全部类型"
            actionTo="/category"
          />
          <div className="mt-6">
            <CategoryQuickLinks />
          </div>
        </section>

        <EditorPicks />
        <NewsPreview />
        <SpecialPreview />
        <AboutBand />
      </main>
      <SiteFooter />
    </div>
  );
}